"use client";

import { useState } from "react";
import { ChevronDownIcon } from "@/components/feature-icons";

const FAQS: { q: string; a: string }[] = [
  {
    q: "Is there an annual contract?",
    a: "No fixed annual or multi-year commitment is required for Small and Team access. Platform access is billed monthly.",
  },
  {
    q: "Are prices inclusive of VAT?",
    a: "No. KleipData prices shown on this website are exclusive of VAT. VAT will be added at the applicable rate.",
  },
  {
    q: "Are included searches really unlimited?",
    a: "Included intelligence services can be used without purchasing routine search credits, subject to acceptable-use terms and any separately identified third-party data restrictions.",
  },
  {
    q: "Is API access an additional charge?",
    a: "No. API access is included with platform access.",
  },
  {
    q: "Do you charge separately for CRM integration?",
    a: "CRM and casework integration support is included within the agreed implementation scope.",
  },
  {
    q: "Is workflow consultancy included?",
    a: "Yes. Workflow analysis, implementation planning and integration support are included within the agreed scope.",
  },
  {
    q: "Are Land Registry searches additional?",
    a: "Supported England & Wales Land Registry title and registered ownership searches are included with platform access.",
  },
  {
    q: "How are KYC and AML checks charged?",
    a: "KYC and supported AML screening checks are usage-based at £1.50 per call.",
  },
  {
    q: "Can we see the platform before subscribing?",
    a: "Yes. Request a demo and we can show the relevant capabilities and discuss how KleipData could fit your existing workflows.",
  },
  {
    q: "What if we have more than 20 users?",
    a: "Contact us for Large access configured around your deployment and organisational requirements.",
  },
];

export function PricingFaq() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <ul className="mx-auto max-w-3xl divide-y divide-outline-variant/60 border-y border-outline-variant/60">
      {FAQS.map((item, i) => {
        const isOpen = open === i;
        return (
          <li key={item.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 py-5 text-left"
            >
              <span className="text-base font-semibold text-brand-navy">{item.q}</span>
              <ChevronDownIcon
                className={`h-5 w-5 shrink-0 text-brand-electric transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <div
              className={`grid transition-[grid-template-rows] duration-200 ease-out ${
                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-5 pr-9 text-sm leading-relaxed text-on-surface-variant">
                  {item.a}
                </p>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
